import React, { useEffect, useState } from 'react';
import ToolTip from './common/AssetPropertyView';
import './GoBackAndForthPages.css';
import t from './i18n/I18n';
import Storage from './protocol/Storage';
import { ThemeSetup } from './themes/ThemeSetup';
import { HISTORY_BEGIN_URL, HISTORY_END_URL } from './util/Constants';
export default function GoBackAndForthPages() {
  const isAbleToBack = () => !(window.location.href.endsWith('index.html') || window.history.length === 1);
  const [show, setshow] = useState(false);

  const onClickBack = () => {
    window.showForwardHistoryBtn = true;
    window.history.back();
  };

  const onClickForward = () => {
    window.showBackHistoryBtn = true;
    window.history.forward();
    updateComponent();
  };

  const updateComponent = () => {
    setshow((show) => !show);
  };

  useEffect(() => {
    window.showBackHistoryBtn = false;
    window.showForwardHistoryBtn = false;
    window.addEventListener('popstate', onPopState);
    return () => {
      window.removeEventListener('popstate',onPopState);
    };
  }, []);

  const onPopState = (e) => {
    if (window.location.href === Storage.get(HISTORY_BEGIN_URL)) {
      window.showBackHistoryBtn = false;
      updateComponent();
    }
    if (window.location.href === Storage.get(HISTORY_END_URL)) {
      window.showForwardHistoryBtn = false;
      updateComponent();
    }
  };

  const renderHistoryBtn = (onClick, className, tooltipText) => {
    return (
      <ToolTip text={t(tooltipText)}>
        <div
          className={`btn ${className}`}
          onClick={onClick}
          style={{
            backgroundImage: ThemeSetup.getBackgroundURL('arrow_left.svg')
          }}></div>
      </ToolTip>
    );
  };

  return (
    <div name="GoBackAndForthPages">
      <div className="gbf-container flex-row">
        {isAbleToBack() && window.showBackHistoryBtn ? renderHistoryBtn(onClickBack, 'back-btn', 'GO_BACK') : null}
      </div>
      <div className="gbf-container flex-row">
        {window.showForwardHistoryBtn ? renderHistoryBtn(onClickForward, 'forward-btn', 'GO_FORWARD') : null}
      </div>
    </div>
  );
}
